import { IModelJsonValues } from '@sparelabs/http-client-utils'

export enum OrganizationBackupFrequency {
  High = 'high', // once every 15 minutes (pending performance evaluation)
  Medium = 'medium', // once every 1 hour
  Low = 'low', // once every 12 hours
}

export interface IOrganizationBackupSettingsResponse extends IModelJsonValues {
  recoveryEmail: string | null
  recoveryCode: string | null
  driverRecoveryCode: string | null
  backupFrequency: OrganizationBackupFrequency
  lastBackupStartedTs: number | null
  lastBackupTs: number | null
}

export interface IOrganizationBackupSettingsPatchBody {
  recoveryEmail?: string | null
  recoveryCode?: string | null
  driverRecoveryCode?: string | null
  backupFrequency?: OrganizationBackupFrequency
}
